import { WorkOrderStatus } from '@order-management/types';
import { useMemo } from 'react';
import { Columns, Element } from 'react-bulma-components';
import Button from '../../ui/button/button';
import Modal from '../../ui/modal/modal';

export type WorkOrderConfirmStatusUpdateModalProps = {
  show: boolean;
  targetStatus: WorkOrderStatus;
  loading: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function WorkOrderConfirmStatusUpdateModal({
  show,
  targetStatus,
  loading,
  onCancel,
  onConfirm,
}: WorkOrderConfirmStatusUpdateModalProps) {
  const modalTitle = useMemo(() => {
    const title = 'Send Work Order ';
    switch (targetStatus) {
      case WorkOrderStatus.DRAFT: {
        title.concat(' back to drafts');
        break;
      }
      case WorkOrderStatus.QUEUE: {
        title.concat(' to queue');
        break;
      }
    }
    return title;
  }, [targetStatus]);

  const modalSubtitle = useMemo(() => {
    switch (targetStatus) {
      case WorkOrderStatus.DRAFT: {
        return 'Are you sure you want to revert this work order? It will be removed from Genesis Queue and will show up on the creator’s Work Order Drafts dashboard.';
      }
      case WorkOrderStatus.QUEUE: {
        return 'Are you sure you want to send this work order to queue?';
      }
    }
  }, [targetStatus]);

  const confirmButtonText = useMemo(() => {
    switch (targetStatus) {
      case WorkOrderStatus.DRAFT: {
        return 'Send back to drafts';
      }
      case WorkOrderStatus.QUEUE: {
        return 'Send to queue';
      }
    }
  }, [targetStatus]);

  const cancelButtonText = useMemo(() => {
    switch (targetStatus) {
      case WorkOrderStatus.DRAFT: {
        return 'Cancel';
      }
      case WorkOrderStatus.QUEUE: {
        return 'Continue editing';
      }
    }
  }, [targetStatus]);

  return (
    <Modal show={show} title={modalTitle}>
      <Element renderAs="p" my={4}>
        {modalSubtitle}
      </Element>
      <Columns mt={4}>
        <Columns.Column>
          <Button color="primary-dark" outlined onClick={onCancel}>
            {cancelButtonText}
          </Button>
        </Columns.Column>
        <Columns.Column display="flex" justifyContent="flex-end">
          <Button color="primary-dark" onClick={onConfirm} loading={loading}>
            {confirmButtonText}
          </Button>
        </Columns.Column>
      </Columns>
    </Modal>
  );
}

export default WorkOrderConfirmStatusUpdateModal;
